import { AutoPause } from './../../../tracker/autopause/autopause';
import { TrackingSettingsPage } from './../../tracking-settings/tracking-settings';
import { TrackingService } from './../../../providers/tracking.service';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController, ModalController, LoadingController } from '@ionic/angular';
import { EventProvider, NearbyEventNew, ParticipantSearchListModel } from '../../../providers/event/event';
import { LoaderProvider } from '../../../providers/loader/loader';
import { Storage } from '@ionic/storage';
import { SessionProvider } from '../../../providers/session/session';
import { EventEmitter } from 'events';
import { Subject } from 'rxjs';
import { ParticipantsPageMode } from '../../../providers/nearby-participants.service';
import { UserProvider } from '../../../providers/user/user';
import { Router } from '@angular/router';
import { SubscriptionProvider } from 'src/providers/subscription.provider';
import { LocationProvider } from 'src/tracker/location-handler';
import { StorageProvider } from 'src/providers/storage-service/storage-service';

/**
 * Generated class for the NearbyEventParticipantSearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-nearby-event-participant-search',
  templateUrl: 'nearby-event-participant-search.html',
  styleUrls:['./nearby-event-participant-search.scss']
})
export class NearbyEventParticipantSearchPage {
  searchTxt: string = "";
  autoCompleteTimer?: any = null;;
  autoCompleteList: ParticipantSearchListModel[] = [];
  activeItem: any;
  locater: any = null;
  friends = [];
  mode: ParticipantsPageMode = ParticipantsPageMode.DEFAULT;

  colors = [
    "#f44336",
    "#e91e63",
    "#9c27b0",
    "#673ab7",
    "#3f51b5",
    "#2196f3",
    "#03a9f4",
    "#00bcd4",
    "#009688",
    "#4caf50",
    "#8bc34a",
    "#cddc39",
    "#ffeb3b",
    "#ffc107",
    "#ff9800",
    "#ff5722",
    "#795548",
    "#9e9e9e",
    "#607d8b",
    "#00d483",
    "#d40064",
    "#3be6ff",
    "#ff3bce",
    "#473dff",
    "#3dff76",
    "#c0ff3d"
  ];

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private translate: TranslateService,
    private loadingCtrl: LoadingController,
    public router:Router,
    private eventService: EventProvider,
    private sessionService: SessionProvider,
    private modalCtrl: ModalController,
    private userService: UserProvider,
    public trackingService: TrackingService,
    private subscriptionProvider:SubscriptionProvider,
    private loadingDefCtrl:LoadingController,
    private sharedState:SubscriptionProvider,
    private storageService:StorageProvider
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};

    this.activeItem = state['activeItem'];
    if(state){
      this.locater = this.sharedState.getLocater();
    }
    console.log('locater from service', this.locater)
    // this.locater = state['locater'];

    this.mode = state['mode'] || ParticipantsPageMode.DEFAULT;
    this.userService.getMyFriends().then(friendList => {
      this.friends = friendList;
    });
    console.log('mode: ' + this.mode);
    this.subscriptionProvider.removeSub.next(true);
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter NearbyEventParticipantSearchPage');
  }

  onLocationExportChange() {
    this.trackingService.options.locationExport = !this.trackingService.options.locationExport;
    if (!this.trackingService.options.locationExport) {
      this.trackingService.removePos();
    }
    this.trackingService.updateTrackingSettings();
    this.trackingService.reconfigurePlugin();
  }

  autocompleteKeyUp(event) {
    if (this.autoCompleteTimer) {
      clearInterval(this.autoCompleteTimer);
      this.autoCompleteTimer = null;
    }
    if (event.target.value == null) {
      return;
    }
    if (event.target.value.length > 2) {
      this.autoCompleteTimer = setTimeout(() => {
        this.eventService.searchNearbyParticipant(event.target.value).then((values) => {
          console.log('event.target.value: ', event.target.value);
          console.log('values: ', values);
          this.autoCompleteList = values;
          this.autoCompleteList = this.autoCompleteList.filter(x => this.activeItem.participants.find(y => y.lid === x.lid) ? false : true)
        });
      }, 400)
    } else {
      this.autoCompleteList = [];
    }
  }

  async autoCompleteSelect(item: ParticipantSearchListModel) {

    const loader = await this.loadingDefCtrl.create({
      message: this.translate.instant("GLOBAL_LOADING")
    })
    loader.present();

    if (!this.activeItem.participants) this.activeItem.participants = [];

    item.colorIndex = this.getNextIndex();

    let img = new Image();
    let canvas = document.createElement('canvas');

    await new Promise((resolve) => {
      img.onload = () => {
        let canvas = document.createElement('canvas'),
          ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        let base64;

        ctx.strokeStyle = this.colors[item.colorIndex];
        ctx.lineWidth = 9;

        ctx.save();
        ctx.beginPath();
        ctx.arc(2 * 8, 2 * 8, 2 * 5, 0, Math.PI * 2, true);
        ctx.stroke();
        ctx.closePath();
        ctx.clip();

        ctx.drawImage(img, 5, 5, 4 * 5.5, 4 * 5.5);

        ctx.beginPath();
        ctx.arc(0, 0, 2, 0, Math.PI * 2, true);
        ctx.clip();
        ctx.closePath();
        ctx.restore();

        base64 = canvas.toDataURL();
        item.img = base64;
        resolve(null);

      }

      img.src = "/assets/imgs/default-image-32@1x.png";

    });
    img = null;
    canvas = null;
    this.activeItem.participants.push(item);
    console.log('this.activeItem.participants: ', this.activeItem.participants);

    localStorage.setItem('participants', JSON.stringify(this.activeItem.participants));

    this.autoCompleteList.splice(this.autoCompleteList.findIndex(x => x.lid === item.lid), 1);

    loader.dismiss();
  }

  getNextIndex() {
    if (this.activeItem.participants.length === 0) return 0;

    let indexes = [];
    this.activeItem.participants.forEach(x => indexes.push(x.colorIndex));

    indexes = indexes.sort();
    let counted = [];
    for (let i = 0; i < this.colors.length; i++) {
      let cnt = 0;
      for (let z = 0; z < indexes.length; z++) {
        if (indexes[z] === i) {
          cnt++;
        }
      }
      counted.push(cnt);
    }

    let min = 0;

    for (let i = 1; i < counted.length; i++) {
      if (counted[min] > counted[i]) {
        min = i;
      }
    }

    return min;

    //counted.mi
    //counted.min
  }

  async openSettingsPage() {
    const modal = await this.modalCtrl.create({component:TrackingSettingsPage});

    modal.onDidDismiss().then(({ data }) => {
      this.trackingService.updateTrackingSettings();
      if (!this.locater) return;
      if (this.trackingService.options.autoPause) {
        AutoPause.getInstance().run();
      }
      this.trackingService.options.placement
        ? this.locater.setPlacement(true)
        : this.locater.removePlacement();
      if (data?.markerChanged) {
        this.locater.refreshMarker();
      }
    });

    modal.present();
  }

  remove(participant: ParticipantSearchListModel) {
    this.activeItem.participants.splice(
      this.activeItem.participants.findIndex(x => x.lid === participant.lid)
      , 1);
    console.log(this.activeItem.participants);
    this.storageService.create().then(()=>{
      this.storageService._storage.set('participants' + this.sessionService.profile.forName + this.sessionService.profile.surName, this.activeItem.participants).then(() => {
        console.log('set, name=' + this.activeItem.participants);
      })
    })
  }

  public get modeValue(): typeof ParticipantsPageMode {
    return ParticipantsPageMode;
  }
}
